import { conexaoDB } from "./db";

async function saveAtalhosIniciais(atalhos) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["atalhos-iniciais"], "readwrite")
    .objectStore("atalhos-iniciais");
  objectStore.clear();
  atalhos.forEach((a) => {
    objectStore.add(a);
  });
}

async function saveSincronizacao(sync) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["sincronizacoes"], "readwrite")
    .objectStore("sincronizacoes");
  //objectStore.clear();
  objectStore.add(sync);
}

async function getSincronizacoes() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db
      .transaction(["sincronizacoes"])
      .objectStore("sincronizacoes")
      .getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

async function getAtalhosDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db
      .transaction(["atalhos-iniciais"])
      .objectStore("atalhos-iniciais")
      .getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

export { saveAtalhosIniciais, saveSincronizacao, getSincronizacoes, getAtalhosDB };
